import React from "react";
import { ArrowRight, Undo2 } from "lucide-react";

export default function DirectionBadge({ direction }) {
  const isReturn = direction === "return";
  const Icon = isReturn ? Undo2 : ArrowRight;
  return (
    <span
      data-testid={`direction-badge-${isReturn ? "return" : "forward"}`}
      className={`inline-flex items-center gap-1 text-[11px] font-semibold rounded-full px-2 py-0.5 whitespace-nowrap ${
        isReturn ? "bg-[#FBE4DC] text-[#C24127]" : "bg-[#E4ECF7] text-[#1D4E89]"
      }`}
    >
      <Icon className="h-3 w-3 shrink-0" /> {isReturn ? "Return" : "Forward"}
    </span>
  );
}
